<template>
  <v-app>
    <v-container class="vContainer" fluid>
      <v-row v-if="laderboradData" align="center" style="min-height: 100vh;">
        <v-col cols="12" lg="5">
          <v-card style="background-color: rgba(0, 0, 0, 0.75); border: solid 5px rgba(2, 1, 1, 0.9);">
            <v-row justify="center" class="my-5">
              <v-col cols="12" class="d-flex justify-center align-center">
                <v-img
                  :src="bokkaLogo"
                  height="200"
                  contain
                ></v-img>
              </v-col>
              <v-col cols="12" class="px-10 py-5">
                <div class="text-center">
                  <span class="text-h4 my-5" style="color: white;">{{ laderboradData.Nombre }} </span>
                </div>
                <br>
                <span class="text-h5 my-5" style="color: white;">{{ laderboradData.Desc }} </span>
              </v-col>
              <v-col cols="12" class="px-10 py-5">
                <v-sheet
                  class="px-10 py-3 d-flex flex-column"
                  color="white"
                  elevation="0"
                  height="auto"
                  rounded>
                  <span class="text-h4 font-weight-medium text-center">{{ laderboradData.NProducto }}s Consumidas</span>
                  <IOdometer class="iOdometer text-h2 font-weight-bold text-center" :value="laderboradData.Counter"></IOdometer>
                </v-sheet>
              </v-col>
              <v-col cols="12" class="px-10 py-5">
                <v-sheet
                  class="px-10 py-3 d-flex justify-center"
                  elevation="0"
                  height="auto"
                  style="background-color: rgba(0,255,0, 0.5); color: white;"
                  rounded>
                  <span class="text-h5 font-weight-medium d-flex align-center mr-5">Precio Por {{ laderboradData.NProducto }}*: </span>
                  <span class="iOdometer text-h2 font-weight-bold d-flex align-center" style="color: white;">$</span>
                  <IOdometer class="iOdometer text-h2 font-weight-bold" style="color: white;" :value="progressValue.price"></IOdometer>
                </v-sheet>
              </v-col>
              <!-- <v-col cols="12" class="px-10 py-5">
                <v-sheet
                  class="px-10 py-3 d-flex flex-column"
                  color="white"
                  elevation="0"
                  height="auto"
                  rounded>
                  <span class="text-h4 my-5">Nivel 5</span>
                  <span class="text-h5 text-end"> {{ progressValue.backwards }} pts. Restantes para el siguiente nivel </span>
                  <v-progress-linear
                    :value="progressValue.progress"
                    color="red darken-4"
                    height="20"
                    rounded/>
                  <div class="d-flex justify-space-between">
                    <span class="text-subtitle-1">500</span>
                    <span class="text-subtitle-1">600</span>
                  </div>
                </v-sheet>
              </v-col> -->
              <!-- <v-col cols="5" class="mx-3">
                <v-sheet
                  class="px-10 py-3 d-flex flex-column"
                  color="white"
                  elevation="0"
                  height="auto"
                  rounded>
                  <v-row>
                    <v-col cols="12">
                      <span class="text-h6"> Siguiente Nivel </span>
                    </v-col>
                    <v-col cols="12">
                      <v-sheet
                        class="px-10 py-3 d-flex flex-column"
                        color="grey"
                        elevation="0"
                        height="auto"
                        rounded="xl">
                        <span class="text-center font-weight-bold text-h5"> 6 </span>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
              <v-col cols="5" class="mx-3">
                <v-sheet
                  class="px-10 py-3 d-flex flex-column"
                  color="white"
                  elevation="0"
                  height="auto"
                  rounded>
                  <v-row>
                    <v-col cols="12">
                      <span class="text-h6"> Puntos Actuales </span>
                    </v-col>
                    <v-col cols="12">
                      <v-sheet
                        class="px-10 py-3 d-flex flex-column"
                        color="grey"
                        elevation="0"
                        height="auto"
                        rounded="xl">
                        <span class="text-center font-weight-bold text-h5"> 50 </span>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col> -->
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="7">
          <v-card style="background-color: rgba(0, 0, 0, 0.75); border: solid 5px rgba(2, 1, 1, 0.9);">
            <v-row 
              style="overflow-y: auto; max-height: 92dvh; transition: all 0.3s ease-in-out;" 
              no-gutters>
              <v-col cols="12" class="d-flex justify-space-between align-center">
                <v-img
                  :src="bokkaLogo"
                  height="100"
                  contain
                ></v-img>
              </v-col>
              <v-col cols="12" class="mb-4">
                <v-sheet
                  class="px-10 d-flex flex-column"
                  color="white"
                  elevation="0"
                  height="auto"
                  rounded>
                  <div class="d-flex justify-space-between">
                    <span class="text-h4 my-5">Nivel {{ laderboradData.currentLevel + 1 }}</span>
                  </div>
                  <span v-if="laderboradData.existNext" class="text-h4 text-end"> {{ progressValue.backwards }} {{ laderboradData.NProducto }}s Para El Siguiente Nivel </span>
                  <span v-else class="text-h4 text-end"> Has Alcanzado El Máximo Nivel </span>
                  <v-progress-linear
                    :value="progressValue.progress"
                    color="red darken-4"
                    height="20"
                    rounded/>
                  <div class="d-flex justify-space-between">
                    <span class="text-h4">{{ progressValue.min }}</span>
                    <span class="text-h4">{{ progressValue.max }}</span>
                  </div>
                </v-sheet>
              </v-col>
             <!--  <v-col cols="3" style="overflow-y: hidden; max-height: 70dvh;"> -->
              <v-col cols="2">
                <div class="table-items-top"></div>
                <div 
                  v-for="(level, index) in laderboradData.Levels.length" 
                  :style="{ 
                    backgroundColor: level == laderboradData.currentLevel + 1 ? `rgba(0,255,0, 0.5)` : `rgba(${browns[Math.floor(level/2)]}, 0.7)`, 
                    border:  level == laderboradData.currentLevel + 1 ? `rgba(255,250,205, 1)` : `solid 2px rgba(${browns[Math.floor(level/2)]}, 1)`,
                    borderBottomLeftRadius: `20px`,
                    borderTopLeftRadius: `20px`,
                  }" 
                  :key="index"
                  :class="[ level == laderboradData.currentLevel + 1 ? 'table-item-level' : 'table-items']" >
                  <span class="font-weight-bold"> Nivel {{ level }} </span>
                </div>
              </v-col>
              <v-col cols="1">
                <div class="table-items-top"></div>
                <div 
                  v-for="(level, index) in laderboradData.Levels.length" 
                  :key="index"
                  :style="{
                    backgroundColor: level == laderboradData.currentLevel + 1 ? `rgba(0,255,0, 0.5)` : ``, 
                    border:  level == laderboradData.currentLevel + 1 ? `rgba(255,250,205, 1)` : ``,
                  }"
                  :class="[ level == laderboradData.currentLevel + 1 ? 'table-item-level' : 'table-items']" >
                </div>
              </v-col>
              <v-col cols="5">
                <div
                  :style="{
                    backgroundColor:`#B71C1C`, 
                    borderTopRightRadius: `20px`,
                    borderTopLeftRadius: `20px`,
                  }"  
                  class="table-items-top">
                  <span> Rango de {{ laderboradData.NProducto }} </span>
                </div>
                <div 
                  v-for="(level, index) in laderboradData.Levels.length" 
                  :key="index"
                  :style="{ 
                    backgroundColor: level == laderboradData.currentLevel + 1 ? `rgba(0,255,0, 0.5)` : `rgba(${browns[Math.floor(level/2)]}, 0.7)`, 
                    border:  level == laderboradData.currentLevel + 1 ? `rgba(255,250,205, 1)` : `solid 2px rgba(${browns[Math.floor(level/2)]}, 1)`,
                  }" 
                  :class="[ level == laderboradData.currentLevel + 1 ? 'table-item-level' : 'table-items']">
                  <span>{{ laderboradData.Levels[level-1].i }} - {{ laderboradData.Levels[level-1].f }}</span>
                </div>
              </v-col>
              <v-col cols="1">
                <div class="table-items-top"></div>
                <div 
                  v-for="(level, index) in laderboradData.Levels.length" 
                  :key="index"
                  :style="{
                    backgroundColor: level == laderboradData.currentLevel + 1 ? `rgba(0,255,0, 0.5)` : ``, 
                    border:  level == laderboradData.currentLevel + 1 ? `rgba(255,250,205, 1)` : ``,
                  }"
                  :class="[ level == laderboradData.currentLevel + 1 ? 'table-item-level' : 'table-items']" >
                </div>
              </v-col>
              <v-col cols="3">
                <div
                  :style="{
                    backgroundColor:`#B71C1C`, 
                    borderTopRightRadius: `20px`,
                    borderTopLeftRadius: `20px`,
                  }" 
                  class="table-items-top">
                  <span>Precio por {{ laderboradData.NProducto }} *</span>
                </div>
                <div 
                  v-for="(level, index) in laderboradData.Levels.length" 
                  :key="index"
                  :style="{ 
                    backgroundColor: level == laderboradData.currentLevel + 1 ? `rgba(0,255,0, 0.5)` : `rgba(${browns[Math.floor(level/2)]}, 0.7)`, 
                    border:  level == laderboradData.currentLevel + 1 ? `rgba(255,250,205, 1)` : `solid 2px rgba(${browns[Math.floor(level/2)]}, 1)`,
                    borderBottomRightRadius: `20px`,
                    borderTopRightRadius: `20px`,
                  }" 
                  :class="[ level == laderboradData.currentLevel + 1 ? 'table-item-level' : 'table-items']" >
                  <span> ${{ laderboradData.Levels[level-1].p }} </span>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card style="background-color: rgba(0,0,0,0.7); border: solid 2px rgba(0, 0, 0, 0.7);">
            <v-card-title class="d-flex justify-center text-h2" style="color: white;"> *Aplican Restricciones - Limitado a {{laderboradData.Levels[laderboradData.Levels.length-1].f}} {{laderboradData.NProducto}}s </v-card-title>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-else align="center" justify="center" style="min-height: 100vh;">
        <v-col cols="9">
          <v-card style="background-color: rgba(0, 0, 0, 0.75); border: solid 5px rgba(2, 1, 1, 0.9);">
            <v-row justify="center" class="my-5">
              <v-col cols="12" class="d-flex justify-center align-center">
                <v-img
                  :src="bokkaLogo"
                  height="200"
                  contain
                ></v-img>
              </v-col>
              <v-col cols="12" class="px-10 py-5">
                <v-sheet
                  class="px-10 py-3 d-flex flex-column"
                  color="white"
                  elevation="0"
                  height="auto"
                  rounded>
                  <span class="text-h4 font-weight-medium text-center"> Error al encontrar la información solicitada </span>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog v-model="soldOut" fullscreen persistent>
        <v-container fluid class="d-flex align-center justify-center fill-height" style="background-color: rgba(0, 0, 0, 0.8);">
          <v-card flat class="d-flex align-center justify-center align-center fill-height" color="transparent" width="100%">
            <span class="text-h2 font-weight-bold px-5 py-3 d-flex align-center justify-center soldOut-item">
              SOLD OUT
            </span>
          </v-card>
        </v-container>
      </v-dialog>

    </v-container>
  </v-app>
</template>

<script>
import 'odometer/themes/odometer-theme-default.css';
export default {
  name: '',
  components: { IOdometer: () => {
        return import('vue-odometer')
    } },
  props: {},
  computed: {
    progressValue() {
      if(this.laderboradData && this.loaded){
        let min = this.laderboradData.Levels[this.laderboradData.currentLevel].i;
        let max = this.laderboradData.Levels[this.laderboradData.currentLevel].f;
        let price = this.laderboradData.Levels[this.laderboradData.currentLevel].p;
  
        while (this.laderboradData.Counter > max && this.laderboradData.existNext) {
          this.getDinamicData()
        }
  
        return { 
          progress: (((this.laderboradData.Counter - min) / (max - min)) * 100), 
          backwards: max - this.laderboradData.Counter, 
          price: price,
          min,
          max};
      }else{
         return { 
          progress: 0, 
          backwards: 100, 
          price: 0,
          min: 0,
          max: 0};
      }
    }
  },
  emits: [],
  data() {
    return {
      bokkaLogo: require("@/assets/img/logos/logo_bokka_dark_mode.png"),
      browns: [
        '78, 52, 46',
        '100, 69, 60',
        '125, 90, 75',
        '141, 110, 99',
        '161, 136, 127',
        '188, 170, 164',
      ],
      product: '',
      loaded: false,
      soldOut: false,
      laderboradData: {
        Counter: 0,
        Levels:[
          {
            i: 0,
            f: 0,
            p: 0
          }
        ],
        Nombre: '',
        Multiplicador: 0,
        currentLevel: 1,
        existNext: true,
      },
    }
  },
  methods: {
    listener(){
      this.$store.getters.getFirebaseApp.database.queryBuilderListener(
        `AYB/Niveles/${this.$route.params.fecha}/${this.$route.params.producto}`,
        null,
        (snapshot) => {
          if (snapshot.exists()) {
            this.product = this.$route.params.producto
            this.laderboradData = snapshot.val()
            this.laderboradData.Counter = this.laderboradData.Counter * this.laderboradData.Multiplicador
            this.laderboradData.existNext = true
            this.getDinamicData()
          }else{
            this.laderboradData = null
          }
          this.loaded = true
        }
      );
    },
    getDinamicData(){
      const level = this.laderboradData.Levels.length-1
      const levelActual = this.laderboradData.Levels.findIndex((level) => {
        return (level.i <= this.laderboradData.Counter) && (level.f >= this.laderboradData.Counter)
      })

      if(this.laderboradData.Levels[level].f > this.laderboradData.Counter){
        if(levelActual >= 0){
          this.laderboradData.currentLevel = levelActual
          this.laderboradData.existNext = true
          this.soldOut = false
        }else if(this.laderboradData.Counter > 0){
          this.laderboradData.currentLevel = 4
          this.laderboradData.existNext = false
        } else {
          this.laderboradData.currentLevel = 0
          this.laderboradData.existNext = true
          this.soldOut = false
        }
      }else{
        this.laderboradData.currentLevel = 4
        this.laderboradData.existNext = false
        this.soldOut = true
      }
    }
  },
  mounted(){
    this.listener()
  }
}
</script>

<style scoped>
/* Diseño del fondo de la vista */
.vContainer{
  height: 100dvh;
  max-height: 100dvh;
  background: linear-gradient(rgba(0, 0, 0, 0.75), #00000026),
  url("../../../assets/img/bokka-img-1.webp") no-repeat center center / cover;
}

.table-items-top,
.table-items{
  height: 3.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: xx-large;
  color: white;
}

.table-items{
  margin: 1rem 0;
}

.table-item-level{
  height: 4.7rem;
  margin: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: xx-large;
  color: white;
  animation: pulse 1.5s ease-in-out infinite;
  /* color: rgb(0, 0, 0); */
}

.iOdometer {
    font-size: 2em;
    margin: 0;
    color: #B71C1C;
}

.soldOut-item{
  width: 100%;
  height: 10rem;
  font-size: 3rem;
  transform: rotate(-45deg);
  background-color: red; 
  color: white; 
}

/* ANIMACAO */
@keyframes pulse {
  0% {
    box-shadow: 
      0  0px 0 0 rgba(0, 255, 0, 0.5),
      0  0px 0 0 rgba(0, 255, 0, 0.5);
  }
  50% {
    box-shadow: 
      0 -5px 0 0 rgba(22, 177, 22, 0.7),
      0  5px 0 0 rgba(22, 177, 22, 0.7);
  }
  100% {
    box-shadow: 
      0  0px 0 0 rgba(0, 255, 0, 0.5),
      0  0px 0 0 rgba(0, 255, 0, 0.5);
  }
}

</style>
